import { api } from './client'

/**
 * Os quatro níveis, como o back os nomeia. A ordem numérica é a ordem de
 * exigência — e é ela que a tela usa para ordenar, não o texto.
 */
export type NivelDeIdentificacao =
  | 'Aberto'
  | 'VinculoDoCanal'
  | 'ConfirmacaoDeDado'
  | 'Humano'

export type LinhaDaMatriz = {
  tipo: string
  nivel: NivelDeIdentificacao
  ordem: number

  /** Veio de parâmetro CTGF, e não do padrão em código. */
  deParametro: boolean
}

/**
 * 🔴 `editavel` vem do servidor e é sempre `false`.
 *
 * Não é redundância: a tela não decide sozinha que a matriz é somente leitura —
 * ela **repete o que o servidor declara**. Um dia em que a regra mudar, muda num
 * lugar só.
 */
export type Matriz = {
  editavel: boolean
  validadeMinutos: number
  tentativasMaximas: number
  digitosDeConfirmacao: number
  camposConfirmaveis: string[]
  linhas: LinhaDaMatriz[]
}

export type EntregaNoLog = {
  id: number
  tipo: string
  referencia: string

  /** Telefone/@ para onde o documento foi. É dado pessoal — ver `PRI-03` da 027. */
  destinatario: string

  entregueEm: string
  assistenteId: number | null
  assistente: string | null
  nivelExigido: NivelDeIdentificacao
  nivelAtingido: NivelDeIdentificacao

  /** O NOME do campo confirmado — nunca o valor. */
  campoConfirmado: string | null

  conversaId: number
  contatoId: number | null
  contato: string | null
  nomeDoArquivo: string | null
}

export type PaginaDoLog = {
  total: number
  pagina: number
  tamanho: number
  linhas: EntregaNoLog[]
}

export type FiltroDoLog = {
  contatoId?: number
  tipo?: string
  referencia?: string
  de?: string
  ate?: string
}

export const identificacao = {
  matriz: () => api.get<Matriz>('/identificacao/matriz'),

  log: (marca: string, filtro: FiltroDoLog = {}) => {
    const busca = new URLSearchParams()

    // Filtro vazio não vira `?tipo=` — parâmetro em branco chega ao back como
    // string vazia e o `IsNullOrWhiteSpace` o ignora, mas a URL fica ilegível
    // no log de acesso, que é onde alguém vai procurar o que foi consultado.
    if (filtro.contatoId) busca.set('contatoId', String(filtro.contatoId))
    if (filtro.tipo) busca.set('tipo', filtro.tipo)
    if (filtro.referencia) busca.set('referencia', filtro.referencia)
    if (filtro.de) busca.set('de', filtro.de)
    if (filtro.ate) busca.set('ate', filtro.ate)

    const consulta = busca.toString()

    return api.get<PaginaDoLog>(
      `/marcas/${marca}/entregas-de-documento${consulta ? `?${consulta}` : ''}`,
    )
  },
}
